<template>
  <div class="loading">
    <vue-loading
      type="spiningDubbles"
      color="rgb(90, 193, 221)"
      :size="{ width: '80px', height: '80px' }"
      class="loading-element "
    ></vue-loading>
  </div>
</template>

<script>
import { VueLoading } from "vue-loading-template"

export default {
  name: "Loading",
  components: {
    VueLoading,
  },
}
</script>

<style scoped>
.loading {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  display: block;
  opacity: 0.7;
  background-color: #fff;
  z-index: 50;
  text-align: center;
}
.loading-element {
  position: absolute;
  top: 40%;
  left: 0;
  right: 0;
  z-index: 100;
}
</style>
